









































































































































import axios from 'axios';
// import Vue from 'vue';
import Session from '@/models/Session';
import Entidad from '@/models/Entidad';
export default {
	name: 'session',
	inject: ['responsive'],
	props: {
		cuit: {
			type: Number,
			required: false,
		},
	},
	data() {
		var validateCuit = (rule, cuit, callback) => {
			if (cuit) {
				if (cuit.length !== 11) callback(new Error('El cuit debe ser de 11 caracteres'));
				else callback();
			} else if (!cuit.match(/^[0-9]+$/)) callback(new Error('Sólo números, sin caracteres ni espacios'));
			else callback();
		};
		return {
			searchEntidades: '',
			searchEmpresas: '',
			publicPath: process.env.BASE_URL,
			window: '',
			delete: false,
			show: false,
			imprimiendo: false,
			loading: false,
			loadingSessions: false,
			loadingEmpresa: false,
			activa: true,
			//tableEntidades: [],
			showEntidades: false,
			form: {
				cuit: '',
			},
			rules: {
				cuit: [
					{
						required: true,
						message: 'El cuit es obligatorio.',
						trigger: 'blur',
					},
					{ validator: validateCuit },
				],
			},
		};
	},
	computed: {
		filteredList() {
			const q = (this.searchEntidades || '').toLowerCase().trim();
			if (!q) return this.entidadesLogin;
			return this.entidadesLogin.filter(item => {
				const completo = (item.descri_entidad + item.codigo_entidad).toLowerCase();
				return q.split(' ').every(v => completo.includes(v));
			});
		},
		filteredEmpresas() {
			const list = this.tableData || [];
			const q = (this.searchEmpresas || '').toLowerCase().trim();
			if (!q) return list;
			const tokens = q.split(/\s+/);
			return list.filter(item => {
				const haystack = `${item.cuit || ''} ${item.razonsocial || ''}`.toLowerCase();
				return tokens.every(t => haystack.includes(t));
			});
		},
		entidadesLogin() {
			return this.$store.state.perfil.entidadesLogin;
		},
		tableData() {
			return this.$store.state.perfil.tableSessions;
		},
		entidadSelected() {
			return this.$store.state.perfil.entidadSelected;
		},
		cambiaEntidad() {
			return localStorage.getItem('cambia_entidad');
		},
	},
	watch: {
		visible(v) {
			this.show = !this.show;
		},
		cuit(cuit) {
			this.form.cuit = cuit;
			//this.onSubmit();
		},
		'$route.params.welcome': {
			handler: function (welcome) {
				switch (this.$route.path) {
					case '/welcome/sessions':
						this.activa = true;
						break;
					case '/welcome/new':
						this.activa = false;
						break;
				}
			},
			deep: true,
			immediate: true,
		},
	},
	filters: {
		capitalize: function (value) {
			if (!value) return '';
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
		},
		numeric: function (value) {
			return new Intl.NumberFormat('de-DE').format(value);
		},
	},
	methods: {
		// goBack() {
		// 	this.$router.go(-2);
		// },
		disabledInactiv({ row }) {
			if (!row.activa) return 'disabled';
		},
		disabledRow({ row }) {
			if (row.suspendido || (!row.desktop && !this.responsive.isMobile) || (!row.mobile && this.responsive.isMobile)) return 'disabled';
		},
		onSubmit() {
			this.loading = true;
			let config = {
				cuit: this.form.cuit,
			};
			this.$store
				.dispatch('newSession', config)
				.then(response => {
					if (response.success) {
						this.tableEntidades = response.entidades;
						axios.defaults.headers.common.Cooperativa = response.empresacuit;
						//axios.defaults.headers.common.Cooperativa = 11111111111;
						this.$store.dispatch('saveCuit', response.empresacuit);
						this.changeWhitelabel(response.empresacuit, response.host);
						this.showEntidades = true;
						this.loadingEmpresa = false;
						this.$router.push('/welcome/sessions');
						return;
					} else {
						this.loading = false;
						this.$notify({
							message: response.msg ? response.msg : 'Ocurrió un error a cargar la nueva sesion',
							type: 'warning',
							duration: 9000,
						});
					}
				})
				.catch(error => {
					this.loading = false;
					this.$message({
						type: 'error',
						message: 'Ocurrió un error a cargar la nueva sesion',
					});
				});
		},

		selectEntidad(record) {
			if (!record.activa) return false;
			this.loadingEmpresa = true;
			let params = {
				mobile: this.responsive.isMobile,
				cuit: this.$store.state.config.cuit,
				codent: record.codigo_entidad,
			};
			this.$store.dispatch('getUserData', params).then(result => {
				if (result.data.success) {
					this.$store.dispatch('setEntidad', record.codigo_entidad);
					this.$store.dispatch('setEntidadSelected', record);
					axios.defaults.headers.common.Entity_ID = record.codigo_entidad;
					//Manejamos el unico perfil 1 Cliente
					let perfil = 1;
					//this.$store.dispatch('getParametrosModulos', this.tableData);
					this.$router.push(`/${perfil}/dashboard`);
					this.show = false;
				} else {
					this.loadingEmpresa = false;
					let mensaje = result.data.mensaje ? result.data.mensaje : 'Se produjo un error al obtener los datos';
					this.$alert(mensaje, 'Error: EternumNET', {
						confirmButtonText: 'Ok',
						center: this.responsive.isMobile ? true : false,
					});
				}
				this.loadingEmpresa = false;
			});
		},
		selectEmpresa(record: Session) {
			if (!record) return false;
			if (record.suspendido || (!record.desktop && !this.responsive.isMobile) || (!record.mobile && this.responsive.isMobile) || this.delete)
				return false;

			this.$store.dispatch('reset');

			this.loadingEmpresa = true;
			axios.defaults.headers.common.Cooperativa = record.cuit;
			//axios.defaults.headers.common.Cooperativa = 11111111111;
			this.$store.dispatch('saveCuit', record.cuit);
			let config = {
				cuit: record.cuit,
			};
			this.$store
				.dispatch('buscoEntidad', config)
				.then((response: { success: boolean; msg: string; entidades: Entidad[] }) => {
					if (response.success) {
						this.$store.dispatch('getParametrosModulos', this.tableData);
						if (response.entidades.length === 1) {
							let entidad = this.entidadSelected.codigo_entidad ? this.entidadSelected : response.entidades[0];
							let params = {
								mobile: this.responsive.isMobile,
								cuit: this.$store.state.config.cuit,
								codent: entidad.codigo_entidad,
							};
							this.$store
								.dispatch('getUserData', params)
								.then(result => {
									if (result.data.success) {
										// pongo a la unica entidad como entidad seleccionada
										this.$store.dispatch('setEntidadSelected', entidad);
										//seteo el codigo de entidad en el store
										this.$store.dispatch('setEntidad', result.data.usuario.codent);
										
										//guardo la entidad en los headers
										axios.defaults.headers.common.Entity_ID = entidad.codigo_entidad
											? entidad.codigo_entidad
											: result.data.usuario.codent;
										this.$store.dispatch('setAdmin', record.admin);
										this.$store.dispatch('setRemoteToken', record.accesstoken);
										this.menu = this.$store.state.perfil.menu;
										//cambio el estilo
										this.changeWhitelabel(record.cuit, record.url);
										this.loadingEmpresa = false;
										//si hay unico perfil redirecciono al q hay, sino pongo 0.
										//let perfil = result.data.usuario.perfiles.length === 1 ? result.data.usuario.perfiles[0].id : 0;
										let perfil = result.data.usuario.perfile_default ? result.data.usuario.perfile_default : 1;
										this.$router.push(`/${perfil}/dashboard`);
										this.show = false;
									} else {
										this.loadingEmpresa = false;
										let mensaje = result.data.mensaje ? result.data.mensaje : 'Se produjo un error al obtener los datos';
										this.$alert(mensaje, 'Error: EternumNET', {
											confirmButtonText: 'Ok',
											center: this.responsive.isMobile ? true : false,
										});
									}
								})
								.catch(() => {
									this.loading = false;
									this.$message({
										type: 'error',
										message: 'Ocurrió un error',
									});
								});
						} else {
							if (localStorage.getItem('cambia-entidad')) {
								this.selectEntidad(this.entidadSelected);
								localStorage.removeItem('cambia-entidad');
							}
							this.$store.dispatch('setRemoteToken', record.accesstoken);
							this.changeWhitelabel(record.cuit, record.url);
							this.showEntidades = true;
							this.loadingEmpresa = false;
							return;
						}
					} else {
						this.loadingEmpresa = false;
						this.$message({
							type: 'error',
							message: response.msg ? response.msg : 'Ocurrió un error',
						});
					}
				})
				.catch(() => {
					this.loading = false;
					this.$message({
						type: 'error',
						message: 'Ocurrió un error',
					});
				});
		},
		changeWhitelabel(cuit: number, url: string) {
			var a = document.getElementById('linkwhitelabel') as HTMLAnchorElement;
			//a.href = this.publicPath + 'whitelabel/' + cuit + '/colors.css';
			a.href = `${this.publicPath}whitelabel/${cuit}/colors.css`;
			this.$store.dispatch('setActiveHost', url);
			this.$store.dispatch('saveCuit', cuit);
		},
		newSession() {
			this.$router.push('/welcome/new');
		},
		deleteSession(index, row) {
			this.delete = true;
			this.$confirm('¿Está seguro que desea eliminar la empresa de sus sesiones activas?', 'Atención', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				center: this.responsive.isMobile ? true : false,
				type: 'warning',
			})
				.then(() => {
					this.$store.dispatch('deleteSession', row).then(result => {
						if (result) {
							this.loadingEmpresa = true;
							this.$store.dispatch('getActiveSessions').then(() => {
								this.$message({
									type: 'success',
									message: 'Se eliminó la sesión',
								});
							});

							this.loadingEmpresa = false;
						}
					});
				})
				.catch(() => {
					this.delete = false;
					// this.$message({
					// 	type: 'info',
					// 	message: 'Eliminación cancelada',
					// });
				});
		},
		doLogout(): void {
			this.$confirm('Su sesión se cerrará. ¿Desea continuar?', 'Atención', {
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancelar',
				type: 'warning',
				center: this.responsive.isMobile ? true : false,
			}).then(() => {
				this.$store.dispatch('logout').then(() => {
					this.$store.dispatch('reset');
					window.location.reload();
				});
			});
		},
	},
	mounted() {
		//if (this.config.cuit) this.form.cuit = this.config.cuit;
		this.window = window;
		this.loadingSessions = true;
		this.$store.dispatch('getActiveSessions').then(() => {
			if (this.$store.state.perfil.entidadSelected || localStorage.getItem('cambia-entidad') || this.entidadSelected) {
				axios.defaults.headers.common.Entity_ID = this.entidadSelected.codigo_entidad;
				var rec = this.$store.state.perfil.tableSessions.filter((item: Session) => {
					return item.cuit === this.$store.state.config.cuit;
				});
				this.loadingSessions = false;
				this.selectEmpresa(rec[0]);
			} else {
				if (this.$store.state.perfil.tableSessions.length === 0) this.$router.push('/welcome/new');
				if (this.$store.state.perfil.tableSessions.length === 1 && this.$store.state.config.cuit === null)
					this.selectEmpresa(this.$store.state.perfil.tableSessions[0]);
				this.loadingSessions = false;
			}
			this.loadingSessions = false;
		});
	},
};
